/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML / Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { selfServiceSessionLogPagePermissionsAny } from "@/model/constants/permissionTypes";

export default [
  {
    url: "/pages/selfservice",
    name: "Sıcak Satış Ekranı",
    slug: "sale",
    icon: "icon-hot-sale-screen",
    permission : "sale_screen"
   // notAdmin : true
  },
  {
    url: null,
    name: "Sıcak Satış Kayıtları",
    icon: "icon-hot-sales-reports",
    submenu: [
      {
        url: "/pages/orderLogs",
        name: "Sıcak Satış Detayları",
        slug: "orderLogs",
        icon: "icon-cash-box",
        permission: "hot_sale_record_read"
      },
      {
        url: "/pages/totalOrderLogs",
        name: "Toplam Ciro Raporu",
        slug: "orderLogs",
        icon: "icon-discount",
        permission: "total_giro_report_read"
      },
      {
        url: "/pages/expenses",
        name: "Giderlerim",
        slug: "expenses",
        icon: "icon-rich",
        permission: "expense_read_write"
      },
      {
        url: "/pages/expenseDefinitions",
        name: "Gider Tipleri",
        slug: "expenseDefinitions",
        icon: "icon-rich",
        permission: "expense_type",
        forCenter: true
      }
    ]
  },
  {
    name: "Raporlar",
    url: null,
    icon: "icon-cash-box",
    submenu: [{
      url: "/pages/Reports/Inventory-Report",
      name: "Envanter Raporu",
      slug: "inventory-report",
      icon: "icon-inventory",
      permission: "envanter_report_read"
    }, {
      url: "/pages/reports/branch-report",
      name: "Şube Ciro Raporu",
      slug: "branch-report",
      icon: "icon-inventory",
      permission: "branch_giro_report_read"
    }, {
      url: "/pages/reports/category-report",
      name: "Kategori Ciro Raporu",
      slug: "category-report",
      icon: "icon-inventory",
      permission: "category_report_read"
    }, {
      url: "/pages/reports/product-report",
      name: "Ürün Ciro Raporu",
      slug: "product-report",
      icon: "icon-inventory",
      permission: "product_giro_report_read"
    }, {
      url: "/pages/reports/BranchComparativeReport",
      name: "Şube Karşılaştırma",
      forCenter: true,
      slug: "branch-comparative-report",
      icon: "icon-inventory",
      permission: "branch_comparison_report"
    }, {
      url: "/pages/reports/giro-by-time",
      name: "Zamana Göre Ciro Raporu",
      slug: "report-by-time",
      icon: "icon-inventory",
      permission: "time_giro_report_read"
    }, {
      url: "/pages/reports/giro-by-date",
      name: "Tarihe Göre Ciro Raporu",
      slug: "report-by-date",
      icon: "icon-inventory",
      permission: "date_giro_report_read"
    },
      {
        url: "/pages/reports/raw-material-consumption",
        name: "Hammadde Tüketim Raporu",
        slug: "raw-material-consumption",
        icon: "icon-inventory",
        permission: "rawmaterial_consume_report_read"
      },
      {
        url: "/pages/reports/raw-material-consumption-loss",
        name: "Zaiyat Hammadde Tüketim Raporu",
        slug: "raw-material-consumption-loss",
        icon: "icon-inventory",
        permission: "rawmaterial_consume_report_read"
      },
      {
        url: null,
        name: "Mood Raporları",
        slug: "mood-reports",
        forCenter: true,
        icon: "icon-inventory",
        submenu: [
          {
            url: "/pages/reports/customer-mood-report",
            name: "Kullanıcı Mood Raporu",
            slug: "customer-mood-report",
            forCenter: true,
            icon: "icon-inventory",
            permission: "mood_report_read"
          },
          {
            url: "/pages/reports/branch-balance-report",
            name: "Şube Bakiye Raporu",
            slug: "branch-balance-report",
            forCenter: true,
            icon: "icon-inventory",
            permission: "mood_report_read"
          },
          {
            url: "/pages/reports/customer-mood-report-new",
            name: "Kullanıcı Mood Raporu (Yeni)",
            slug: "customer-mood-report-new",
            forCenter: true,
            icon: "icon-inventory",
            permission: "mood_report_read"
          },
          {
            url: "/pages/reports/branch-balance-report-new",
            name: "Şube Bakiye Raporu (Yeni)",
            slug: "branch-balance-report-new",
            forCenter: true,
            icon: "icon-inventory",
            permission: "mood_report_read"
          },
        ]
      },
      /* {
        url: "/pages/reports/campaign-gift-report",
        name: "Kampanya Hediye Raporu",
        slug: "campaign-gift-report",
        forCenter: true,
        onlyMainCenter: true,
        icon: "icon-inventory",
        permission: "campaign_gift_report"
      }, */
      {
        url: "/pages/reports/wallet-transaction",
        name: "Cüzdan Tüketim Raporu",
        slug: "wallet-transaction",
        icon: "icon-inventory",
        permission: "wallet_consume_report_read"
      },
      {
        url: "/pages/reports/day-report",
        name: "Gün Raporları",
        slug: "wallet-transaction",
        icon: "icon-inventory",
        permission: "day_report_read"
      },
      {
        url: "/pages/reports/wallet-offset",
        name: "Cüzdan Mahsuplaşması",
        slug: "wallet-offset",
        icon: "icon-inventory",
        permission: "wallet_offset_read"
      },
      {
        url: "/pages/reports/wallet-accouting-report",
        name: "Cüzdan Muhasebe Raporu",
        slug: "wallet-accouting-report",
        icon: "icon-inventory",
        permission: "wallet_accounting_report"
      },
      {
        url: "/pages/selfServiceSessionLog",
        name: "Personel İşlem Raporu",
        slug: "selfServiceSessionLog",
        icon: "icon-inventory",
        permissionsAny: selfServiceSessionLogPagePermissionsAny
      },
      {
        url: "/pages/selfServiceDiagnosticLog",
        name: "Kasa Teşhis Günlüğü",
        slug: "selfServiceDiagnosticLog",
        icon: "icon-inventory",
        onlySuperAdmin: true
      }
    ]
  },
  {
    name: "Stoklar",
    url: null,
    icon: "icon-barn",
    submenu: [{
      url: "/pages/Stocks",
      name: "Stok Listesi",
      icon: "icon-checklist2",
      slug: "stockList",
      permission: "stock_list_read"
    },
      {
        url: "/pages/Bills",
        name: "Faturalarım",
        icon: "icon-bills",
        slug: "billList",
        permission: "bill_read_create"
      },
      {
        url: "/pages/MonthlyStockTransfer",
        name: "Ay Sonu Stok Sayımı ve Devir",
        icon: "icon-transfer-coffee",
        slug: "monthlyStockTransfer",
        permission: "stock_taking_create_read"
      }
    ]
  },
  {
    url: "/pages/StockOrder",
    name: "Siparişlerim",
    icon: "icon-checklist2",
    slug: "stockOrderList"
  },
  {
    url: "/pages/Targets",
    name: "Hedefler",
    slug: "targers",
    icon: "icon-units",
  },
  {
    url: null,
    name: "Kampanyalar ve Çekiliş",
    icon: "icon-checklist2",
    submenu: [
      {
        url: "/pages/Campaign",
        name: "Kampanyalar",
        icon: "icon-checklist2",
        slug: "campaign",
        permissionsAny: ["campaign_read", "campaign_write"]
      },
      {
        url: "/pages/Draws",
        name: "Çekilişler",
        icon: "icon-checklist2",
        slug: "draws",
        permission: "draw_read"
      },
      {
        url: "/pages/CustomerTickets",
        name: "Kullanıcı Biletleri",
        icon: "icon-checklist2",
        slug: "customer-tickets",
        forCenter: true,
        onlyMainCenter: true,
        permission: "draw_read"
      }
    ]
  },
  {
    name: "Ürünler",
    icon: "icon-products",
    submenu: [{
      url: "/pages/Products",
      name: "Ürün Listesi",
      icon: "icon-product-list",
      slug: "productList",
      permission: "product_list_read"
    },
      {
        url: "/pages/ProductCategories",
        name: "Ürün Kategori Listesi",
        icon: "icon-role",
        slug: "productCategoryList",
        permission: "product_category_list_read"
      },
      {
        url: "/pages/RawMaterials",
        name: "Hammaddeler",
        icon: "icon-raw-materials",
        slug: "rawMaterialList",
        permission: "rawmaterial_list_read"
      },
      {
        url: "/pages/RawMaterialCategories",
        name: "Hammadde Kategorileri",
        icon: "icon-raw-materials",
        slug: "rawMaterialCategoryList",
        permission: "rawmaterial_category_list_read",
        forCenter: true
      },
      {
        url: "/pages/HalfMadeProducts",
        name: "Yarı Mamüller",
        icon: "icon-semi-products",
        slug: "halfMadeProductList",
        permission: "half_made_read"
      },
      {
        url: "/pages/Recipes",
        name: "Reçeteler",
        icon: "icon-recipe",
        slug: "recipeList",
        permission: "receipt_list_read"
      },
      {
        url: "/pages/ProductExtras",
        name: "Ekstralar",
        icon: "icon-coffee-preparation",
        slug: "productExtraList",
        permission: "extra_list_read"
      },
      {
        url: "/pages/ProductSizes",
        name: "Boylar",
        icon: "icon-coffee-preparation",
        slug: "productSizeList",
        permission: "cup_sizes_read"
      }
    ]
  },
  {
    url: null,
    name: "Şube ve Kullanıcı Listesi",
    icon: "icon-branches",
    submenu: [
      {
        url: "/pages/Branchs",
        name: "Şube Listesi",
        icon: "icon-branches",
        slug: "branchList",
        permission: "branch_list_read"
      },
      {
        url: "/pages/BranchCatalogSync",
        name: "Şube Katalog Aktarımı",
        icon: "icon-transfer-coffee",
        slug: "branchCatalogSync",
        permission: "branch_list_read",
        onlyAdmin: true
      },
      {
        url: null,
        name: "Kullanıcı Listesi",
        icon: "icon-pick-users",
        submenu: [
          {
            url: "/pages/Users",
            name: "Kullanıcı Listesi",
            slug: "users",
            icon: "icon-pick-users",
            permission: "user_read"
          },
          {
            url: "/pages/roles",
            name: "Roller",
            slug: "roles",
            icon: "icon-pick-users",
            onlySuperAdmin: true
          }
        ]
      }
    ]
  },
  {
    name: "İndirim ve Zaiyatlar",
    permission : "loss_read",
    icon: "icon-pick-box",
    submenu: [
      {
        url: "/pages/discount",
        name: "İndirimler/İkramlar",
        slug: "discounts",
        icon: "icon-rich",
        permission: "discount_read"
      },
      {
        url: "/pages/discountReason",
        name: "İndirim Sebepleri",
        slug: "discount-reason",
        icon: "icon-rich",
        permission: "discount_reasons_read",
        forCenter: true
      },
      {
        url: "/pages/losses",
        name: "Zayiatlar",
        slug: "losses",
        icon: "icon-logistic",
        permission :"loss_read"
      },
      {
        url: "/pages/lossReasons",
        name: "Zayiat Sebepleri",
        slug: "lossReasons",
        icon: "icon-logistic",
        permission: "loss_reason_read",
        forCenter: true
      },
      {
        url: "/pages/loss-deletion",
        name: "Zayiat Silme",
        slug: "loss-deletion",
        icon: "icon-pick-truck",
        permission: "loss_read"
      }
    ]
  },
  {
    url: "/pages/Units",
    name: "Birim Listesi",
    slug: "units",
    icon: "icon-units",
    permission: "unit_read"
  },
  {
    name: "Mobil Uygulama",
    icon: "icon-card",
    forCenter: true,
    submenu: [
      {
        url: "/pages/wallet/manual-topup",
        name: "Manuel Cüzdan Yükleme ve Silme",
        slug: "wallet-manual-topup",
        icon: "icon-inventory",
        permission: "wallet_manual_topup"
      },
      {
        url: "/pages/blackLists",
        name: "Kara Liste",
        slug: "blackList",
        icon: "icon-pick-users",
        forCenter: true
      },
      {
        url: "/pages/moodfelek-settings",
        name: "MoodFelek Ayarları",
        slug: "moodfelek",
        icon: "icon-logistic",
        permission: "mood_felek_settings",
        forCenter: true
      },
      {
        url: "/pages/app-settings",
        name: "Panel Ayarları",
        slug: "appSettgins",
        icon: "icon-card",
        permission: "panel_settings",
        forCenter: true
      },
      {
        url: "/pages/MoodImage",
        name: "Mood Resim Ayarları",
        slug: "appSettgins",
        icon: "icon-card",
        permission: "mood_image_settings",
        forCenter: true
      },
      {
        url: "/pages/MoodImage",
        name: "Mood Resim Yönetimi",
        slug: "moodimages",
        forCenter: true,
        icon: "icon-card",
      }
    ]
  },
  {
    url: "/pages/documents",
    name: "Dökümanlar",
    slug: "documents",
    icon: "icon-pick-users"
  },
  {
    url: "/pages/PriceLists",
    name: "Fiyat Listeleri",
    slug: "priceLists",
    forCenter: true,
    onlyMainCenter: true,
    icon: "icon-card",
    permission: "price_list_read"
  },
  {
    name: "BM İletişim Sistemi",
    icon: "icon-pick-users",
    forCenter: true,
    submenu: [
      {
        url: "/pages/userwantcategory",
        name: "BM İletişim Kategorileri",
        slug: "user-want-category",
        onlyAdmin: true,
        icon: "icon-card",
      },
      {
        url: "/pages/userwant",
        name: "Kanban Görünümü",
        slug: "cis-kanban",
        icon: "icon-pick-filter",
      },
      {
        url: "/pages/CisTable",
        name: "Tablo Görünümü",
        slug: "cis-table",
        icon: "icon-checklist2",
      }
    ]
  },
  {
    url: null,
    name: "Otomasyon ve POS Ayarları",
    icon: "icon-card",
    submenu: [
      {
        url: "/pages/pos-settings",
        name: "Pos Ayarları",
        slug: "posSettings",
        icon: "icon-card",
        permission: "pos_settings"
      },
      {
        url: "/pages/all-pos-settings",
        name: "Toplu Pos Ayarları",
        slug: "allposSettings",
        icon: "icon-card",
        onlyAdmin: true,
        forCenter: true
      },
      {
        url: "/pages/payment-methods",
        name: "Ödeme Tipleri",
        slug: "paymmentMethods",
        icon: "icon-card",
        permission: "payment_type"
      },

      {
        url: null,
        name: "Tedarikçiler",
        icon: "icon-pick-box",
        permission: "supplier",
        submenu: [{
          url: "/pages/Suppliers",
          name: "Tedarikçi Listesi",
          slug: "suppliers",
          icon: "icon-logistic",
        }]
      }
    ]
  }
]
